import { render } from "./Rankingmain.vue?vue&type=template&id=240bb3bf&ts=true"
import script from "./Rankingmain.vue?vue&type=script&lang=ts"
export * from "./Rankingmain.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__